import React from 'react';

import PropTypes from 'prop-types';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

import { STATUS_COLORS, Color, STATUS_COLORS_MAP } from './consts';

type StatusColorIndicatorProps = StylableComponent<HTMLDivElement> & {
  statusColor?: Color;
};
/**
 * A StatusColorIndicator
 * docs.
 */
const StatusColorIndicator = React.forwardRef<
  HTMLDivElement,
  StatusColorIndicatorProps
>(({ style, statusColor = STATUS_COLORS.BLUE, ...rest }, ref) => {
  return (
    <div
      {...rest}
      ref={ref}
      css={[
        {
          width: '6px',
          height: '40px',
          borderRadius: theme.borderRadius.small,
          backgroundColor: STATUS_COLORS_MAP[statusColor],
        },
        style,
      ]}
    />
  );
});

StatusColorIndicator.displayName = 'StatusColorIndicator';

StatusColorIndicator.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Status color */
  statusColor: PropTypes.oneOf(Object.values(STATUS_COLORS)),
};

export default Object.assign(StatusColorIndicator, { COLORS: STATUS_COLORS });
